import { EComponent } from '../models/base';
import { ITag } from '../models/tag.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getAll(component?: EComponent) {
  return request<ITag[]>({
    url: '/public/tags',
    params: {
      lang: 'en',
      component,
    },
    method: 'GET',
  });
}

function listing(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
    component?: EComponent;
  },
) {
  return request<IPaginationData<ITag>>({
    url: '/tags',
    params: query,
    method: 'GET',
  });
}

function getDetail(id: string) {
  return request<ITag>({
    url: `/tags/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<ITag>) {
  return request<ITag>({
    url: `/tags`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<ITag>) {
  return request<ITag>({
    url: `/tags/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<ITag>({
    url: `/tags/${id}`,
    method: 'DELETE',
  });
}

const tagsApi = Object.freeze({
  getAll,
  listing,
  create,
  getDetail,
  remove,
  update,
});

export default tagsApi;
